import { render } from "./BusinessSignUpComponent.vue?vue&type=template&id=09fca25d&scoped=true"
import script from "./BusinessSignUpComponent.vue?vue&type=script&lang=js"
export * from "./BusinessSignUpComponent.vue?vue&type=script&lang=js"

import "./BusinessSignUpComponent.vue?vue&type=style&index=0&id=09fca25d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09fca25d"]])

export default __exports__